<template>
	<div v-if="items.length">
		<div class="row faq-row">
			<div class="columns column12">
				<div v-for="(item, index) in items" :key="index" class="faq-item">
					<collapse
						:header="item.question"
						:content="item.answer"
						:expanded="activeCollapse === index"
						@click="setExpanded(index)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});

const activeCollapse = ref(null);
const setExpanded = (index) => {
	if (activeCollapse.value === index) {
		activeCollapse.value = null;
	} else {
		activeCollapse.value = index;
	}
};
</script>

<style lang="scss" scoped>
.faq-item {
	text-align: left;
	border-top: 1px solid #000;

	&:last-child {
		border-bottom: 1px solid #000;
	}
}

.faq-row {
	max-width: 900px;
	padding: 60px 0 0;

	.columns {
		padding: 0;
	}
}
</style>
